//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    DASHBOARD_PANEL_CREATE_REQUEST,
    DASHBOARD_PANEL_EDIT_REQUEST,
    DASHBOARD_PANEL_DELETE_REQUEST,
    DASHBOARD_PANEL_SEARCH_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    dashboardPanelSearchResult,
    dashboardPanelCreateResult,
    dashboardPanelEditResult,
    dashboardPanelDeleteResult,
} from 'Redux/actions';

function* searchDashboards({ payload }) {
    try {
        let QUERY = `
            query searchDashboards {
                result: searchDashboards {
                    id
                    name
                    sharedWith
                    shared
                    createdBy
                    gadgets {
                        id
                        dashboardId
                        name
                        type
                        settings
                        columnPanel
                        columnOrder
                        refreshSeconds
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) yield put(dashboardPanelSearchResult(data.result))
        else yield put(dashboardPanelSearchResult([]))

    } catch (exc) {
        yield put(dashboardPanelSearchResult([]))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/redux/saga', 'searchDashboards');
    }
}

function* createDashboard({ payload }) {
    try {
        let QUERY = `
            mutation createDashboard ($name: String!) {
                result: createDashboard (name: $name) {
                    id
                    name
                    gadgets {
                        id
                        dashboardId
                        name
                        type
                        settings
                        columnPanel
                        columnOrder
                        refreshSeconds
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data.result) {
            yield put(dashboardPanelCreateResult(data.result))
        } else yield put(dashboardPanelCreateResult(null))

    } catch (exc) {
        yield put(dashboardPanelCreateResult(null))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/redux/saga', 'createDashboard', true);
    }
}

function* editDashboard({ payload }) {
    try {
        let QUERY = `
            mutation updateDashboard ($id: String, $name: String!) {
                result: updateDashboard (id: $id, name: $name) {
                    id
                    name
                    gadgets {
                        id
                        dashboardId
                        name
                        type
                        settings
                        columnPanel
                        columnOrder
                        refreshSeconds
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload.data,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(dashboardPanelEditResult(data.result))
        }

    } catch (exc) {
        yield put(dashboardPanelEditResult(null))
        ExceptionManager(exc, 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/redux/saga', 'editDashboard', true);
    }
}

function* watchDashboardPanelRequests() {
    yield takeEvery(DASHBOARD_PANEL_SEARCH_REQUEST, searchDashboards);
    yield takeEvery(DASHBOARD_PANEL_CREATE_REQUEST, createDashboard);
    yield takeEvery(DASHBOARD_PANEL_EDIT_REQUEST, editDashboard);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchDashboardPanelRequests)
    ]);
}